import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPES = ["Boutique hotel", "Private villa", "Homestay", "Eco-resort", "Multi-property portfolio"];
const EMPTY = { name: "", email: "", phone: "", property_type: "", message: "" };

const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-2 block text-xs font-semibold uppercase tracking-[0.16em] text-ink/60">{label}</span>
    {children}
  </label>
);

export const EnquiryForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await axios.post(`${API}/enquiries`, form);
      setStatus("sent");
      setForm(EMPTY);
      toast.success("Thank you — our team will be in touch shortly.");
    } catch (err) {
      setStatus("idle");
      toast.error("Could not send. Please check your details or contact us on WhatsApp.");
    }
  };

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="rounded-[28px] bg-sand p-6 text-ink sm:p-10">
      <h3 className="font-display text-2xl">List Your Property</h3>
      <p className="mt-2 text-sm text-ink/60">Tell us about your property — we'll assess it and propose a management agreement tailored to your goals.</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2">
        <Field label="Full name"><input required minLength={2} value={form.name} onChange={set("name")} className="input" data-testid="enquiry-name-input" /></Field>
        <Field label="Email"><input required type="email" value={form.email} onChange={set("email")} className="input" data-testid="enquiry-email-input" /></Field>
        <Field label="Phone / WhatsApp"><input value={form.phone} onChange={set("phone")} className="input" data-testid="enquiry-phone-input" /></Field>
        <Field label="Property type">
          <select value={form.property_type} onChange={set("property_type")} className="input" data-testid="enquiry-type-select">
            <option value="">Select…</option>
            {TYPES.map((t) => <option key={t}>{t}</option>)}
          </select>
        </Field>
      </div>
      <div className="mt-5">
        <Field label="Message"><textarea required minLength={5} rows={4} value={form.message} onChange={set("message")} className="input resize-none" data-testid="enquiry-message-input" /></Field>
      </div>
      <button type="submit" disabled={status === "sending"} className="btn-primary group mt-7 w-full justify-center sm:w-auto" data-testid="enquiry-submit-btn">
        {status === "sending" && <Loader2 className="h-4 w-4 animate-spin" />}
        {status === "sent" && <Check className="h-4 w-4" />}
        {status === "sent" ? "Enquiry sent" : "Send enquiry"}
        {status === "idle" && <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />}
      </button>
    </form>
  );
};
